module.exports = __webpack_public_path__ + "static/nav-contact-2-58c048c22e223ee80999daaa24aa84fa.jpg";